import { useEffect, useState } from "react";
import { useWindowDimensionsContext } from "../../../../common-deprecated/containers/WindowDimensionsProvider";
import {
    BREAKPOINT_XS,
    BREAKPOINT_SM,
    BREAKPOINT_MD,
    BREAKPOINT_LG,
    BREAKPOINT_XL,
    BREAKPOINT_XXL,
} from "../../../../common-deprecated/constants";
import type { BreakPointDirectionType } from "../../../../common-deprecated/themes/common";

type BreakpointType = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

const allBreakpoints: Record<BreakpointType, number> = {
    xs: BREAKPOINT_XS,
    sm: BREAKPOINT_SM,
    md: BREAKPOINT_MD,
    lg: BREAKPOINT_LG,
    xl: BREAKPOINT_XL,
    xxl: BREAKPOINT_XXL,
};

// Get the next breakpoint based on the provided breakpoint value.
const breakpointNext = (breakpoints: Record<BreakpointType, number>, value: BreakpointType): BreakpointType => {
    const keys = Object.keys(breakpoints) as BreakpointType[];
    const index = keys.indexOf(value);
    return index < keys.length ? keys[index + 1] : keys[0];
};

/**
 * returns true when corresponding css breakpoint is active, analogue to getBreakPointString
 * Todo: Rename this to useBreakpoint when build is deprecated
 */
export const useAphBreakpoint = (type: BreakPointDirectionType, breakpoint: BreakpointType): boolean => {
    const windowWidth = useWindowDimensionsContext().width;
    const [isActive, setActive] = useState(false);

    const getBreakPointValue = (name: BreakpointType): number => {
        return allBreakpoints[name];
    };

    useEffect((): void => {
        const breakpointValue = getBreakPointValue(breakpoint);
        if (type === "up") setActive(windowWidth >= breakpointValue);
        else if (type === "down") setActive(windowWidth <= breakpointValue);
        else if (type === "only") {
            const nextBreakpoint = getBreakPointValue(breakpointNext(allBreakpoints, breakpoint));
            setActive(windowWidth > breakpointValue && windowWidth <= nextBreakpoint);
        }
    }, [windowWidth]);

    return isActive;
};
